import { snakeCase } from 'lodash';
export var TaskEvents = /*#__PURE__*/ function(TaskEvents) {
    TaskEvents["OpenTaskDrawer"] = "open_task_drawer";
    TaskEvents["TaskUpdate"] = "task_update";
    TaskEvents["TaskCreate"] = "task_create";
    TaskEvents["TaskDelete"] = "task_delete";
    TaskEvents["BulkTaskUpdate"] = "bulk_task_update";
    TaskEvents["BulkTaskDelete"] = "bulk_task_delete";
    TaskEvents["DependentTaskCreate"] = "dependent_task_create";
    TaskEvents["DependentTaskDelete"] = "dependent_task_delete";
    return TaskEvents;
}({});
export const TaskEventsMap = Object.keys(TaskEvents).reduce((acc, key)=>{
    acc[snakeCase(key).toUpperCase()] = TaskEvents[key];
    return acc;
}, {});
